import type { ListBuilderList } from '../../../types';
import {
	AGING_REQUIRED_FIELDS,
	BASE_FILTER_RULES,
	INVOICE_MOBILE_CARD_CONFIG,
} from '../shared';

/**
 * Past due 1-30 days - outstanding invoices 1 to 30 days past due
 */
export const pastDue1To30List: ListBuilderList = {
	id: 'default-invoices-past-due-1-30',
	inheritsFrom: 'default-invoices-all',
	cacheTTL: 600000,
	name: 'Past Due 1-30',
	type: 'default',
	active: true,
	sortOrder: 3,
	description: 'Outstanding invoices 1 to 30 days past due',
	defaultSortId: 'date-asc',
	requiredFields: AGING_REQUIRED_FIELDS,
	filterRules: {
		...BASE_FILTER_RULES,
		invoicePaymentStatus: {
			defaultValue: [{ id: 'outstanding', label: 'Outstanding' }],
		},
		invoiceDueDateRange: {
			defaultValue: [
				{
					id: 'past-due-1-30',
					label: '1-30 Days Past Due',
					data: {
						startDate: '{{DATE:-30d}}',
						endDate: '{{DATE:-1d}}',
					},
				},
			],
		},
		// Clear the default 90-day invoice date filter so all matching invoices show
		invoiceDateRange: {
			defaultValue: [],
		},
	},
	mobileCardConfig: INVOICE_MOBILE_CARD_CONFIG,
};
